module.exports = __webpack_public_path__ + "static/famiglia-a578b80a80ffa06f17ebf67eb70418b7.png";